import React from "react"

import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell"

type State = {
    isHovered   : boolean
    showPopover : boolean
}

export default class FieldTaskDescription_TableCell extends React.Component<FieldTableCellProps, State> {

    constructor(props:FieldTableCellProps) {
        super(props)
    }

    get style() {
        return getTableCellStyle(this.props)
    }

    render() {
        const value = this.props.field.getViewValue(this.props.listItem.item)

        return (
            <div className="cell-flex ui5-txt-less-important-small p-l-6" style={this.style}>
                {!! value && <div className="txt-truncate">{value}</div>}
            </div>
        )
    }
}
